import Icon from '../components/Icon.vue'

Icon.register({
  thumbtack: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M298 214.3L285.8 96H328C341.3 96 352 85.3 352 72V24C352 10.7 341.3 0 328 0H56C42.7 0 32 10.7 32 24V72C32 85.3 42.7 96 56 96H98.2L86 214.3C37.5 236.8 0 277.3 0 328 0 341.3 10.7 352 24 352H160V456C160 457.2 160.3 458.5 160.8 459.6L184.8 507.6C187.8 513.5 196.2 513.5 199.2 507.6L223.2 459.6A8-8 0 0 1 224 456V352H360C373.3 352 384 341.3 384 328 384 276.8 346 236.6 298 214.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/thumbtack.js
// module id = p7Nd
// module chunks = 144